// extracted by mini-css-extract-plugin
export default {"primaryButton":"button_primaryButton__CLS7J","outlinedButton":"button_outlinedButton__zEevA"};